import { render, staticRenderFns } from "./VesselVoyageReview.vue?vue&type=template&id=51ac323a&"
import script from "./VesselVoyageReview.vue?vue&type=script&lang=js&"
export * from "./VesselVoyageReview.vue?vue&type=script&lang=js&"
import style0 from "./VesselVoyageReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VesselVoyageReview.vue"
export default component.exports